import Blogs from "./blogs/Blogs"
import BusinessSolutions from "./businessSolutions/BusinessSolutions"
import Careers from "./careers/Careers"
import CoreSolutions from "./coreSolutions/CoreSolutions"
import DataAnnotationDemo from "./dataAnnotationDemo/DataAnnotationDemo"
import HomeHero from "./homeHero/HomeHero"
import IndustryExpertise from "./industryExpertise/IndustryExpertise"
import SecurityCompliance from "./securityCompliance/SecurityCompliance"
import WhyChooseUs from "./whyChooseUs/WhyChooseUs"

const Home = () => {
  return (
    <>
    <HomeHero />
    <CoreSolutions />
    <WhyChooseUs />
    <DataAnnotationDemo />
    <SecurityCompliance />
    <IndustryExpertise />
    <Careers />
    <Blogs />
    <BusinessSolutions />
    </>
  )
}

export default Home